/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from 'react-loading-skeleton';
import axiosInstance from "./../../helpers/axiosInstance";
import Pdf from "react-to-pdf";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Modal,
  Spinner
} from "reactstrap";
import { normalizeUnits } from "moment";

function UtilizationHeader(account) {

  var tabsAux = 0;
  var accountAux = {};
  var stepAux = 0;
  if (account.account != null) {
    accountAux = account.account;
    stepAux = 1;
    tabsAux = 1;
  }

  // build ptoduct two
  let auxBuildProductTwo = {
    system: '20',
    accountNumber: '',
    tid: 1,
    nid: ''
  }

  const [tabToGo, setTabToGo] = useState(0);

  const listStep = [{ title: "Desde" }, { title: "Valor" }, { title: "Hacia" }, { title: "Confirma" }];
  const listStep2 = [{ title: "Desde" }, { title: "Valor" }, { title: "Hacia" }, { title: "Confirma" }];

  const [tabs, setTabs] = useState(tabsAux);
  const [types, setTypes] = useState(0);

  const [cancelationModal, setCancelationModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [processModal, setProcessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const [step, setStep] = useState(stepAux);
  const [step2, setStep2] = useState(0);

  const [productOne, setProductOne] = useState(accountAux);
  const [productTwo, setProductTwo] = useState({});

  const [valueNumberInstallments, setValueNumberInstallments] = useState({});
  const [commission, setCommission] = useState(0);

  const [relatedAccounts, setRelatedAccounts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [accountsToTransfer, setAccountsToTransfer] = useState([]);
  const [historicalTransfer, setHistoricalTransfer] = useState([]);

  const [isLoadingHistorical, setIsLoadingHistorical] = useState(true);


  var createReactClass = require('create-react-class');
  const ref = React.createRef();

  var CardLoan = createReactClass({
    render: function () {
      var accountNumber = this.props.data.accountNumber,
        balance = this.props.data.balance,
        description = this.props.data.description;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer">
            <CardBody className="">
              <Row>
                <div className="col-auto ml-4">
                  <Row>
                    <span class="mb-0">{description} No. {accountNumber}</span>
                  </Row>
                  <Row>
                    <span class="mb-0 text-sm">Deudo <NumberFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }
  });

  async function getProductOrigin(product, tab) {
    await setProductOne(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStep2(s => s + 1);
    }
    await setTabs(tab);
  }

  async function getProductDestiny(product, tab) {
    getCommission();
    await setProductTwo(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStep2(s => s + 1);
    }
    await setTabs(tab);
  }

  async function getCommission() {
    const response = await axiosInstance().get("/WSGYG39_2/api/Inquiries/comissions/" + 2 + "/" + parseFloat(valueNumberInstallments.value.replace(/,/g, '')) + "/" + productOne.accountNumber + "/" + productOne.system)
      .catch(err => {
        return 'err';
      });
    if (response != 'err') {
      setCommission(response.data.cost)
    }
  }

  var Loans = createReactClass({
    render: function () {
      var data = this.props.data;
      var tab = this.props.tab;
      var isOrigin = this.props.isOrigin;
      var newsTemplate;

      if ((data.length > 0)) {
        newsTemplate = data.map(function (item, index) {
          if (isOrigin) {
            return (
              <Row key={index} onClick={() => getProductOrigin(item, tab)}>
                <CardLoan data={item} />
              </Row>
            )
          } else {
            return (
              <Row key={index} onClick={() => getProductDestiny(item, tab)}>
                <CardLoan data={item} />
              </Row>
            )
          }
        })
      } else {
        newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      }
      return (
        <div>
          {newsTemplate}
        </div>
      );
    }
  });


  var CardAccountContact = createReactClass({
    render: function () {
      var aliasAccount = this.props.data.aliasAccount,
        numeroCuenta = this.props.data.numeroCuenta;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer">
            <div className="">
              <Row>
                <div className="col-auto vertical-center">
                  <Row className="m-4">
                    <i className="fas fa-money-bill text-primary" />
                  </Row>
                </div>
                <div className="col">
                  <Row>
                    <span class="mt-1 text-sm h4">{aliasAccount}</span>
                  </Row>
                  <Row>
                    <span class="mt-0 mb-0 text-sm">Ahorros No. {numeroCuenta}</span>
                  </Row>
                  <Row>
                    <span class="mb-1 text-sm"></span>
                  </Row>
                </div>
                <div className="col-auto mr-3 vertical-center">
                  <Row className="m-4">
                    <a className="button"><i className="fas fa-chevron-right" /></a>
                  </Row>
                </div>
              </Row>
            </div>
          </Card>
        </Col>
      );
    }
  });

  async function getContact(product) {
    await setProductTwo(product);
    await setStep(s => s + 1);
  }

  async function goBack(tab, isFirst) {
    if (!isFirst) {
      if (tab === 1) {
        await setStep(s => s - 1);
      } else if (tab === 2) {
        await setStep2(s => s - 1);
      }
    } else {
      setCancelationModal(true);
      await setTabToGo(0);
    }
  }

  var HistoricalTransfers = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <CardHistoricalTransfer key={index}  data={item} />
          )
        }) 
      } else if (isLoadingHistorical) {
        newsTemplate = <Skeleton height={150} count={3} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      } else {
        newsTemplate = <div className="text-center m-4">
          <h2 class="ml-2"> No se encuentran transacciones en el historial. </h2>
        </div>;
      }
      return (
        <div className="col-md-12 p-2" style={{ justifyContent: "space-between" }}>
          {newsTemplate}
        </div>
      );
    }
  });

  var CardHistoricalTransfer = createReactClass({
    render: function () {
      var nut = this.props.data.nut,
      product_Number = this.props.data.product_Number,
      transaction_Value = this.props.data.transaction_Value,
      transaction_Status = this.props.data.transaction_Status,
      date_Transaction = this.props.data.date_Transaction,
      year = this.props.data.date_Transaction.substring(0,3),
      month = this.props.data.date_Transaction.substring(5,6),
      day = this.props.data.date_Transaction.substring(8,9);
      return (
        <div className="shadow" style={{ padding: "10px 15px 0", marginBottom: 16 + 'px', display: "flex", justifyContent: "space-between", flexDirection: "column", position: "relative", padding: 15 + 'px', minHeight: 80 + 'px', borderRadius: 15 + 'px', boxShadow: "0 2px 4px 0 rgb(65 74 83 / 30%)", backgroundColor: "#fff", width: 100 + '%' }}>
          <div style={{ position: "absolute", width: 16 + 'px', height: 16 + 'px', left: 10 + 'px', top: 16 + 'px' }}>
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px' }}><span style={{ fontSize: 12 + 'px', fontWeight: 400, color: "#77899a" }}>{date_Transaction}</span> - Utilización de prestamo Santander </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Ahorros No. {product_Number} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Número de Transacción {nut} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 1 + 'rem', fontWeight: 700, }}> <NumberFormat value={transaction_Value} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </p>
          </div>
        </div>
      );
    }
  });

  async function getTypeAccount(type) {
    await setTypes(type);
  }

  function DivStep({ children }) {
    return <>{children}</>
  }

  function Progress(props) {
    const styleProgress = { width: ((100/props.list.length)-2) + '%' };
    var newsTemplate = props.list.map(function (item, index) {
      if (index === props.current) {
        return <div key={index} className="progress-bar-step-active" style={styleProgress}>
          <span className="stepper-number-active">
            <span className="stepper-label-active">{index + 1}</span>
          </span>
        </div>;
      } else {
        return <div key={index} className="progress-bar-step" style={styleProgress}>
          <span className="stepper-number">
            <span className="stepper-label">{index + 1}</span>
          </span>
        </div>;
      }
    });
    return newsTemplate;
  }

  function LineStepper(props) {
    return (
      <>
        <div style={{ position: "relative"}} className="mt-1 m-4 mb-6">
          <div style={{ position: "absolute", width: '100%'}}>
            <Progress
              current={props.current}
              list={props.listStep}
            ></Progress>
            </div>
        </div>
      </>
    );
  }

  function NavigationButtons(props) {
    var isFirst = props.step === 0;
    return (
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <button class="btn-icon text-primary btn" onClick={() => goBack(props.tab, isFirst)}>
          <span class="btn-inner--icon">
            <i class="fas fa-arrow-left"></i>
          </span>
          <span class="btn-inner--text">{isFirst?'Volver':props.listStep[props.step-1].title}</span>
        </button>
        <button class="btn-icon text-primary btn" disabled={isFirst} onClick={() => setCancelationModal(true)}>
          <span class="btn-inner--text">{props.listStep[props.step+1].title}</span>
          <span class="btn-inner--icon">
            <i class="fas fa-times"></i>
          </span>
        </button>
      </div>
    );
  };

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    if (props.step != childrenArray.length - 1) {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step} listStep={props.listStep}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    } else {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    }
  }

  useEffect(() => {
    async function getProducts() {
      const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Loans")
        .catch(err => {
          return 'err';
        });
      if (request != 'err') {
        if(request.data.summaryProduct.product != null){
          console.log(request.data.summaryProduct);
          setAccounts(request.data.summaryProduct.product.filter(item => !(item.accountType === '6')));
        }
      }
      return request;
    }
    getProducts();
  }, []);

  async function getRelatedAccounts() {
    await setStep(s => s + 1);
    const request = await axiosInstance().get("/WSGYG39_2/api/Consultas/AssociatedAccounts")
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      console.log(request.data);
      setRelatedAccounts(request.data.relatedAccounts.filter(item => (item.status === null)));
    }

    const request2 = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Accounts")
      .catch(err => {
        return 'err';
      });
    if (request2 != 'err') {
      console.log(request2.data);
      setAccountsToTransfer(request2.data.summaryProduct.product)
    }
    setValueNumberInstallments(AuxValueNumberInstallments);
    return request;
  }

  async function getHistoricalTransfer() {
    setIsLoadingHistorical(true);
    const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Transactions/Use")
      .catch(err => {
        setIsLoadingHistorical(false);
        return 'err';
      });
    if (request != 'err') {
      setIsLoadingHistorical(false);
      console.log(request.data);
      setHistoricalTransfer(request.data);
    }
    return request;
  }

  //Value and NumberInstallments
  var AuxValueNumberInstallments = {
    value: '',
    NumberInstallments: '001'
  }
  const valueChange = event => {
    //event.preventDefault();
    //let val = event.target.value;
    //setValue(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    AuxValueNumberInstallments.value = event.target.value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const NumberInstallmentsChange = event => {
    //event.preventDefault();
    //let val = event.target.value;
    //setValue(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    AuxValueNumberInstallments.NumberInstallments = event.target.value;
  }

  const ProductTwoChange = event => {
    auxBuildProductTwo.accountNumber = event.target.value;
  }

  const NIDChange = event => {
    auxBuildProductTwo.nid = event.target.value;
  }

  const TIDChange = event => {
    auxBuildProductTwo.tid = event.target.value;
  }

  async function BuildAccount() {
    await setProductTwo(auxBuildProductTwo);
    setStep2(s => s + 1)
  }
  const ejecutasalir=()=>{
    setCancelationModal(false);
  }
  const transfer = async event => {
    setNotificationModal(false);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    today = yyyy + '' + mm + '' + dd;
    var system = (productTwo.tipoCuenta === 1) ? '20' : (productTwo.tipoCuenta === 2) ? '30' : '20';

    const consulta = {
      AccountNumber: productOne.accountNumber,
      Parameters: [
        productOne.accountNumber,
        productOne.system,
        ((productTwo.numeroCuenta === undefined) ? productTwo.accountNumber : productTwo.numeroCuenta),
        system,
        (productTwo.sequence === undefined) ? "" : productTwo.sequence,
        "NN090D",
        productOne.accountNumber,
        ((productTwo.numeroCuenta === undefined) ? productTwo.accountNumber : productTwo.numeroCuenta),
        today,
        "" + parseFloat(valueNumberInstallments.value.replace(/,/g, '')) * 100,
        valueNumberInstallments.NumberInstallments
      ]
    }

    const request = await axiosInstance().post("/WSGYG39_2/api/transaction/Transfer/Use", consulta)
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      setProcessModal(true);
      setTabs(0);
      setStep(0);
      setStep2(0);
    } else {
      setErrorModal(true);
      setTabs(0);
      setStep(0);
      setStep2(0);
    }
  }

  class NavsTransfer extends React.Component {

    toggleModal = state => {
      setNotificationModal(!notificationModal);
    };
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      setTabs(index);
    };

    render() {
      return (
        <>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={cancelationModal}
            toggle={() => setCancelationModal(!cancelationModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">¿Quieres salir de la transacción?</h5>
                  <p class="header-subtitle">La información que has ingresado hasta el momento se borrará.</p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button class="btn bg-white text-green shadow" type="button" onClick={() => setCancelationModal(false)}> No, volver </button>
                <button class="my-btn btn bg-green text-white shadow" type="button" onClick={() => { setTabs(tabToGo); setCancelationModal(false); setStep(0); setStep2(0); setTabToGo(0) }}> SÍ, SALIR </button>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={errorModal}
            toggle={() => setErrorModal(!errorModal)}
          >
            <div className="p-4">
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/error-transaction.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">La transacción no se pudo realizar</h5>
                  <p class="header-subtitle">Por algún motivo la transaccion no se pudo realizar intentelo más tarde.</p>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={notificationModal}
            toggle={() => this.toggleModal("notificationModal")}
          >
            <div className="modal-header">
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("notificationModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-lock ni-3x" />
                <h4 className="heading mt-4">Verifica la utilización con el número que se envió a tu celular.</h4>
                <form role="form" class="">
                  <div class="code-group">
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                  </div>
                  <div class="text-center">
                    <button onClick={() => transfer()} color="white" block size="lg" className="my-btn btn bg-gradient-primary text-white shadow btn-block btn-lg">
                      Verificar Utilización
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={processModal}
            toggle={() => setProcessModal(!processModal)}
          >
            <div className="p-4">
              <div class="my-modal-header" ref={ref}>
                <img alt="delete-icon" class="my-header-brand-img" src={require("../../assets/img/brand/santander.png").default} />
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transfer.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">Tu transferencia a la cuenta {productTwo.numeroCuenta} {productTwo.accountNumber} fue aprobada.</h5>
                  <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={valueNumberInstallments.value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                      <p style={{ textAlign: "right", margin: 0 }}>7750</p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                        <p style={{ margin: 0 }}>Santander</p>
                        <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                      </div>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                        <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="m-2">
                <button class="my-btn btn bg-gradient-primary text-white shadow btn-block" type="button" onClick={() => { setProcessModal(false); setTabs(0) }}> Continuar </button>
                <Pdf targetRef={ref} filename="comprobante.pdf">
                  {({ toPdf }) => (
                    <button class="btn bg-gradient-white text-gray shadow btn-block btn-icon" type="button" onClick={toPdf}>
                      <span class="btn-inner--icon">
                        <i class="fas fa-download"></i>
                      </span>
                      <span class="btn-inner--text">Descargar comprobante</span>
                    </button>
                  )}
                </Pdf>

              </div>
            </div>
          </Modal>

          <div className="header pb-4 pt-5 pt-md-8">
            <Container fluid>
              <div className="header-body">
                <Nav
                  className="justify-content-center flex-column flex-md-row"
                  id="tabs-icons-text"
                  pills
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 1}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 1
                      })}
                      onClick={e => { if (step > 0 || step2 > 0) { setTabToGo(1); setCancelationModal(true); } else { this.toggleNavs(e, "tabs", 1); }; }}
                      href="#myAccounts"
                      role="tab"
                    >
                      <Row className="justify-content-center m-2">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={require("../../assets/img/illustrations/to-registered-contact.svg").default} />
                        </div>
                      </Row>
                      <Row className="justify-content-center m-2">
                        <p className="mt-3 mb-0 text-bold text-primary" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", lineHeight: 1.43 }}>
                          A mis cuentas
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>



                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 3}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 3
                      })}
                      onClick={e => { if (step > 0 || step2 > 0) { setTabToGo(3); setCancelationModal(true); getHistoricalTransfer();} else { this.toggleNavs(e, "tabs", 3); getHistoricalTransfer();}; }}
                      href="#historical"
                      role="tab"
                    >
                      <Row className="justify-content-center m-2">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={require("../../assets/img/illustrations/see-transfers-made.svg").default} />
                        </div>
                      </Row>
                      <Row className="justify-content-center m-2">
                        <p className="mt-3 mb-0 text-bold text-primary" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", textAlign: "center", lineHeight: 1.43 }}>
                          Ver Utilizaciones
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Container>
          </div>
          <Container className="mb-4" key="container">
            <TabContent activeTab={"tabs" + tabs} key="tab-active">
              <TabPane tabId="tabs0">
                <Container fluid>
                  <div className="text-center m-4">
                    <h2 class="ml-2"> ¿Qué puedes hacer en Utilizaciones de Santander? </h2>
                  </div>
                  <Row className="mt-5 ml-7 mr-7">

                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-exchange-alt"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Realiza una utilización a una cuenta sin inscribir</span> que pertenezcan al banco Santander.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-list-ol"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Consulta las utilizaciones realizadas</span>  y descarga los comprobantes.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs1" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>
                    <Col xl="6" lg="8">
                      <DivStepper step={step} listStep={listStep} tab={1}>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige el préstamo </h2>
                          </div>
                          <Loans data={accounts} tab={1} isOrigin={true}></Loans>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingresa los datos de la Utilización </h2>
                          </div>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <Input
                                placeholder="Valor a utilizar"
                                type="text"
                                onChange={valueChange} />
                              <InputGroupAddon addonType="append">
                                <InputGroupText>
                                  <i className="fas fa-dollar-sign" />
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="far fa-list-alt" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <select onChange={NumberInstallmentsChange} class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
                                <option value="001">1</option>
                                <option value="002">2</option>
                                <option value="003">3</option>
                                <option value="004">4</option>
                                <option value="005">5</option>
                                <option value="006">6</option>
                                <option value="007">7</option>
                                <option value="008">8</option>
                                <option value="009">9</option>
                                <option value="010">10</option>
                                <option value="012">12</option>
                                <option value="024">24</option>
                                <option value="036">36</option>
                              </select>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button disabled={!valueNumberInstallments} onClick={() => getRelatedAccounts()} block size="lg" className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-lg btn-block">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Tus Cuentas </h2>
                          </div>
                          <Loans data={accountsToTransfer} tab={1} isOrigin={false}></Loans>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a transferir </h2>
                          </div>
                          <div className="card p-4 m-4 shadow" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={valueNumberInstallments.value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}>7750</p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  <p style={{ margin: 0 }}>Santander</p>
                                  <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <button onClick={() => this.toggleModal("notificationModal")} className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-block btn-lg mt-5 mb-5">
                            Transferir
                          </button>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs2" className="" key="tab-pane2">
                <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <Col xl="3" lg="2"></Col>

                    <Col xl="6" lg="8">
                      <DivStepper step={step2} listStep={listStep2} tab={2} key="stepper2">
                        <DivStep>
                          <div className="text-center">
                            <h2 class="ml-2"> Elige la cuenta de origen </h2>
                          </div>
                          <Loans data={accounts} tab={2} isOrigin={true}></Loans>
                        </DivStep>
                        <DivStep>
                          <div className="text-center">
                            <h2 class="ml-2"> Ingrese el valor a transferir </h2>
                          </div>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <Input
                                placeholder="Valor a transferir"
                                type="text"
                                onChange={valueChange} />
                              <InputGroupAddon addonType="append">
                                <InputGroupText>
                                  <i className="fas fa-dollar-sign" />
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button disabled={!valueNumberInstallments} onClick={() => setStep2(s => s + 1)} block size="lg" className="my-btn bg-green text-white btn shadow btn-rounded btn-lg btn-block">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep key="step-not-associated-account">
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingresa los datos de la cuenta </h2>
                          </div>
                          <Row>
                            <div className={classnames("radius-left shadow p-3 mt-4 mb-4 ml-6 text-center text-primary cursor-pointer col", {
                              active: types === 1
                            })} onClick={() => getTypeAccount(1)}>
                              Cuenta de Ahorros
                            </div>
                            <div className={classnames("radius-right shadow p-3 mt-4 mb-4 mr-6 mr-4 text-center text-primary cursor-pointer col", {
                              active: types === 2
                            })} onClick={() => getTypeAccount(2)}>
                              Cuenta Corriente
                            </div>
                          </Row>
                          <FormGroup key="form">
                            <InputGroup className="input-group-alternative mt-4 mb-4" key="group-accountNumber">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="far fa-credit-card" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Numero de Cuenta"
                                type="text"
                                onChange={ProductTwoChange} />
                            </InputGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="far fa-list-alt" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <select onChange={TIDChange} class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
                                <option value="1">Cédula de ciudadanía</option>
                                <option value="2">Tarjeta de Identidad</option>
                                <option value="3">Cédula de Extranjería</option>
                              </select>
                            </InputGroup>
                            <InputGroup className="input-group-alternative">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fas fa-id-card" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Documento de Identidad"
                                type="text"
                                onChange={NIDChange} />
                            </InputGroup>
                          </FormGroup>
                          <button onClick={() => BuildAccount()} className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-block btn-lg">
                            Continuar
                          </button>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a transferir </h2>
                          </div>
                          <div className="card p-4 m-4 shadow" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={valueNumberInstallments.value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}>7750</p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  <p style={{ margin: 0 }}>Santander</p>
                                  <p style={{ margin: 0 }}> Ahorros No. {productTwo.accountNumber} </p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <button onClick={() => this.toggleModal("notificationModal")} className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-block btn-lg mt-5 mb-4">
                            Transferir
                          </button>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs3">
                <div className="col-md-12">
                  <HistoricalTransfers data={historicalTransfer}></HistoricalTransfers>
                </div>
              </TabPane>
            </TabContent>
          </Container>
        </>

      );
    }
  }

  return (
    <NavsTransfer></NavsTransfer>
  )
}

export default UtilizationHeader;
